export enum DashboardPage {
  Root = "/",
  Dashboard = "/dashboard",
}
